import {Link} from 'react-router'
import {Card} from '../../../components/card/card.jsx'
import {AlertCard} from '../../../components/alert-card/alert-card.jsx'
import {ScenarioPill} from '../../../components/scenario-pill/scenario-pill.jsx'
import {MetricCard} from '../../../components/metric-card/metric-card.jsx'
import {useDashboardData} from '../dashboard-hooks.js'
import styles from './ops-focused.module.scss'

export function OpsFocusedLayout() {
    const {metrics, active, notifications} = useDashboardData()
    const climate = metrics.data?.climate
    const weather = metrics.data?.weather
    const activeScenarios = active.data?.active || []
    const alerts = notifications.data?.notifications || []

    return (
        <div className={styles.layout}>
            <header className={styles.header}>
                <p className={styles.eyebrow}>Operations</p>
                <h1 className={styles.title}>Dashboard</h1>
            </header>

            <Card title="Active automations" eyebrow={`${activeScenarios.length} running`}>
                {activeScenarios.length === 0 && (
                    <p className={styles.empty}>No scenarios running right now.</p>
                )}
                {activeScenarios.map(s => (
                    <Link key={s.id} to={`/scenarios/${s.id}`} className={styles.scenarioRow}>
                        <div className={styles.scenarioText}>
                            <p className={styles.scenarioName}>{s.name}</p>
                            <p className={styles.scenarioMeta}>{s.type}</p>
                        </div>
                        <ScenarioPill active label="Live"/>
                    </Link>
                ))}
            </Card>

            {alerts.length > 0 && (
                <Card title="Alerts" eyebrow={`${alerts.length} unread`}>
                    {alerts.slice(0, 3).map(n => (
                        <AlertCard
                            key={n.id}
                            severity={n.severity}
                            title={n.title}
                            body={n.body}
                            timestamp={n.createdAt}
                            unread
                        />
                    ))}
                </Card>
            )}

            <div className={styles.metricRow}>
                <MetricCard metricId="climate.temperature" label="Inside" value={climate?.temperatureInside} unit="°C"/>
                <MetricCard metricId="weather.temperature" label="Outside" value={weather?.temperature} unit="°C"/>
                <MetricCard metricId="weather.windSpeed" label="Wind" value={weather?.windSpeed} unit="m/s"/>
            </div>
        </div>
    )
}
